export default __webpack_public_path__ + "07daa29422803bb19aa1214baf90d967.png";